/**
 * The range slider allows for a zero-width range by default - this function ensures that a zero-width range is not committed.
 *
 * Example:
 * [2,2] → [1,2]   // at the top end: pull the lower thumb down a tick ("45+")
 * [0,0] → [0,1]   // elsewhere: push the upper thumb up a tick
 * [0,2] → [0,2]   // distinct thumbs: unchanged
 * @param value - The current values of the slider.
 * @param marks - The marks of the slider.
 * @returns The value of the slider with a zero-width range avoided.
 */
export function avoidZeroWidthRange(value: [number, number], marks: { value: number }[]): [number, number] {
  // A fast drag can cross the thumbs (lower > upper), so normalize to an ascending range first.
  const [lower, upper] = value[0] <= value[1] ? value : [value[1], value[0]];
  if (lower !== upper) {
    return [lower, upper];
  }
  const markValues = marks.map(mark => mark.value);
  const index = markValues.indexOf(lower);
  // At the top end, pull the lower thumb down a tick; otherwise push the upper thumb up a tick.
  return index >= markValues.length - 1 ? [markValues[markValues.length - 2], upper] : [lower, markValues[index + 1]];
}
